import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import BottomToTop from "../../../../../../../components/transitions/bottom-to-top";
import ReactDOM from "react-dom";
import { Header } from "../../../../../../../components/header";
import { useIntl, FormattedMessage } from "react-intl";
import { useEffect } from "react";
import { fetchLogisticsCompanies } from "../../../../../../../../api";
import { fetchUnifiedProcessing } from "../../../../../utils";
import { useState } from "react";
import { useCallback } from "react";
import { BigButton } from "../../../../../../../components/button";
import Toast from "../../../../../../../components/toast";
import MeSkeleton from '../../../../../components/skeleton/index';


export const SelectLogistics = props =>{
    useStyles(cls);
    const { onClose, changeLogistics } = props;
    const Intl = useIntl();
    const [companies, setCompanies] = useState(null);
    const [selectCompany, setSelectCompany] = useState(null);
    const [showOther, setShowOther] = useState(false);
    const [otherValue, setOtherValue] = useState('');

    useEffect(async () =>{
        let response = await fetchLogisticsCompanies();
        setCompanies(fetchUnifiedProcessing(response));
    }, []);

    const selectHandle = useCallback((value, isOther = false) =>{
        setSelectCompany(value);

        setShowOther(isOther);
    }, []);

    const submitHandle = useCallback(() =>{
        if(showOther){
            if(!otherValue){
                Toast(Intl.formatMessage({ id: "select_courier_company", defaultMessage: "Please Select the Courier Company" }));
            }else{
                changeLogistics({ logisticsCompany: otherValue });
                onClose();
            }
        }else{
            if(!selectCompany){
                Toast(Intl.formatMessage({ id: "select_courier_company", defaultMessage: "Please Select the Courier Company" }));
            }else{
                changeLogistics({ logisticsCompany: selectCompany });
                onClose();
            }
        }
    }, [selectCompany, otherValue, showOther]);

    return <div className={cls.SelectLogistics}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "courier_company", defaultMessage: "Courier Company" })}
            onClose={onClose} 
        />

        {
            !!companies ? <React.Fragment>
                <div className={cls.Message}><span><FormattedMessage id="select_courier_company" defaultMessage="Please Select the Courier Company" /></span></div>

                <div className={cls.CompaniesList}>
                    {
                        companies.commonlyUsed?.map((common, index) =>(
                            <a 
                                key={index+common?.name}
                                className={`${cls.CompaniesSub} ${common?.name===selectCompany?cls.Active:''}`} 
                                onClick={() =>selectHandle(common?.name)} 
                            >
                                <img src={common?.iconURL} alt={common?.name} />
                                <span>{common?.name}</span>
                            </a>
                        ))
                    }

                    {
                        companies.logisticsCompanies?.map((company, index) =>(
                            <a 
                                key={index+company?.name}
                                className={`${cls.CompaniesSub} ${company?.name===selectCompany?cls.Active:''}`} 
                                onClick={() =>selectHandle(company?.name, true)} 
                            >
                                <span>{company?.name}</span>
                            </a>
                        ))
                    }
                </div>

                <div className={cls.OtherInput} style={{ display: `${showOther?'block':'none'}` }}>
                    <input 
                        type="text" 
                        placeholder={Intl.formatMessage({ id: "fillin_courier_cpmpany", defaultMessage: "Please fill in your courier company" })} 
                        value={otherValue} 
                        onChange={(evt) =>setOtherValue(evt.target.value)}
                    />
                </div>

                <div className={cls.SelectSubmit}>
                    <BigButton onClick={submitHandle}><FormattedMessage id="confirm" defaultMessage="confirm" /></BigButton>
                </div>
            </React.Fragment> : <React.Fragment>
                <MeSkeleton />
            </React.Fragment>
        }
    </div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show } = props;

	return <React.Fragment>
		<BottomToTop in={show} className={cls.SelectLogisticsModal}>
			<div>
                <SelectLogistics {...props} />
			</div>
		</BottomToTop>
	</React.Fragment>
}

export default props =>{
    if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}